module.exports = __webpack_public_path__ + "img/MensBG.328e4f23.jpg";